import { render, staticRenderFns } from "./PersonsTurnoversReport.vue?vue&type=template&id=c8ffca38&"
import script from "./PersonsTurnoversReport.vue?vue&type=script&lang=js&"
export * from "./PersonsTurnoversReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports